import * as v from "valibot";
import { BaseRecordSchema, baseVals, defineValidation, listVals } from "../../common/validation.common";

export namespace AdminValidation {
    export const Record = defineValidation(BaseRecordSchema);

    export const Create = defineValidation(
        v.object({
            name: baseVals.string(),
            phone: baseVals.phone(),
            email: v.optional(baseVals.email()),
            username: baseVals.username(),
            password: baseVals.password(),
            position: v.optional(baseVals.string()),
            privileges: listVals.stringListEmptiable(),
        }),
    );

    export const Update = defineValidation(
        v.object({
            name: v.exactOptional(baseVals.string()),
            phone: v.exactOptional(baseVals.phone()),
            email: v.exactOptional(baseVals.email()),
            username: v.exactOptional(baseVals.username()),
            password: v.exactOptional(baseVals.password()),
            position: v.exactOptional(baseVals.string()),
            privileges: v.exactOptional(listVals.stringListEmptiable()),
        }),
    );
}
